<template>
<div class="login">
  <ModalAccount ref="ModalAccount" :account="listAccount" @action="selectAccount"></ModalAccount>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-0">
          <v-card-text>
            <router-link to="/" class="text-deco">
              <div class="pb-4">
                <v-img width="250" contain src="/assets/icons/logo-banni.svg" class="mx-auto"></v-img>
              </div>
            </router-link>
            <h1 class="text-center mb-2 font-weight-bold black--text">
              Masuk ke akun anda
            </h1>
            <div class="text-center text-subtitle-2 gray--text mb-5">
              Selamat Datang!, silahkan login untuk masuk ke akun anda.
            </div> 
            <v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text" dismissible> {{alerts.message}} </v-alert>
            <v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
              <div>
                <div class="text-subtitle-2 black--text pb-1">Username</div>
                <v-text-field color="black" autocomplete="true" :rules="usernameRules" @focus="() => fieldErrors.username=''" :error-messages="fieldErrors.username" v-model="username" validate-on-blur single-line outlined class="color-black rounded-lg" height="40" dense></v-text-field>
              </div>
              <div>
                <div class="text-subtitle-2 black--text pb-1">Kata Sandi</div>
                <v-text-field @click:append="showPassword" color="black" :type="passwordType" :rules="passwordRules" @focus="() => fieldErrors.password=''" :error-messages="fieldErrors.password" v-model="password" validate-on-blur single-line outlined class="color-black rounded-lg password-field" height="40" dense :append-icon="passwordIcon" hide-details="auto"></v-text-field>
                <v-row>
                  <v-col cols="6" class="pt-1">
                    <v-checkbox label="Ingat saya" color="primary" class="small-check mt-0"></v-checkbox>
                  </v-col>
                  <v-col cols="6" class="pt-2 text-right text-body-2">
                    <router-link to="/ubah-password" class="text-deco grey--text text--darken-1">
                      <div>Lupa Password?</div>
                    </router-link>
                  </v-col>
                </v-row>
              </div>
              <div class="pt-5">
                <v-btn v-if="isAttempting" x-large depressed color="#1951EF" class="col-12 rounded-lg white--text">
                  <div class="subtitle-2">Sedang Diproses ...</div>
                </v-btn>
                <v-btn v-else x-large depressed color="#1951EF" class="col-12 rounded-lg white--text" type="submit">
                  <div class="subtitle-2">Masuk</div>
                </v-btn>
              </div>
               <div class="text-subtitle-2 text-center py-5">
                <span class="black--text">Belum punya akun?</span>
                <router-link  :to="{ name: 'register' }">
                  <span class="font-weight-bold pl-2 primary-2--text">Daftar</span>
              </router-link>
            </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations
} from 'vuex'
import ModalAccount from '@/views/store/login/ModalChooseAccount'

export default {
  components: {
    ModalAccount
  },
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      passwordIcon: 'mdi-eye',
      usernameRules: [
        v => !!v || 'Nomor Handphone tidak boleh kosong'
      ],
      passwordRules: [
        v => !!v || 'Password tidak boleh kosong',
      ],
      listAccount: [],
    }
  },
  computed: {
    ...mapState('auth', ['isAttempting', 'alerts', 'fieldErrors']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    ...mapMutations('auth', ['success', 'saveListAccount']),

    async validatePaste(val){
      let pasted = await val.clipboardData.getData('text')
      setTimeout(() => {
        if (!parseInt(pasted)) {
            this.username = ''
        }
      })
    },
    showPassword() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
        this.passwordIcon = 'mdi-eye-off'
      } else {
        this.passwordType = 'password'
        this.passwordIcon = 'mdi-eye'
      }
    },
    onLogin() {
      this.listAccount = []
      if (this.$refs.formLogin.validate()) {
        this.login({
          username: this.username,
          password: this.password
        }).then((data) => {
          if (Array.isArray(data)) {
            this.listAccount = data
            this.$refs.ModalAccount.modalShow()
          } else {
            this.selectAccount(data)
          }
        });
      }
    },
    selectAccount(data) {
      if (this.listAccount.length > 0) {
        this.saveListAccount(this.listAccount)
      }
      this.success(data)
      const {
        redirect
      } = this.$route.query;

      if (redirect) {
        this.$router.push(redirect);
      } else {
        this.$router.push({
          name: "home"
        })
      }
    }
  },
  created() {
    this.$store.dispatch('setPageTitle', 'Masuk');
  }
};
</script>
